import React from "react";
import clsx from "clsx";
import useStyles from "./SpecialAlert.style.js";
import {
  Button,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import * as noImage from "./../../assets/images/noImage.png";
import CheckoutLoader from "../CheckoutLoader/CheckoutLoader.js";

const SpecialAlert = ({
  title,
  open,
  handleClose,
  image,
  isLoading = false,
  isCheckout = false,
  handleForceClose,
  updateBtn = false,
  isCartClear = false,
}) => {
  const classes = useStyles();
  // console.log("renderinggggggggggggg")

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      className={classes.customPopup}
      onClose={updateBtn ? null : isCheckout ? handleForceClose : handleClose}
    >
      {/* <DialogContent className={classes.customPopup} >
                <DialogContentText className={classes.customText}>
                {title}
                </DialogContentText>
            </DialogContent> */}
      {isLoading ? (
        <CheckoutLoader />
      ) : (
        <>
          {image && (
            <div className={classes.imgDiv}>
              <CardMedia
                className={classes.placeholderImg}
                component="img"
                src={image || noImage.default}
              />
            </div>
          )}
          {title && (
            <DialogTitle className={classes.customText}>{title}</DialogTitle>
          )}
          <DialogActions className={classes.customAction}>
            {updateBtn ? (
              <Button
                className={classes.updateActionText}
                onClick={handleClose}
              >
                Update
              </Button>
            ) : isCartClear ? (
              <Button className={classes.actionText} onClick={handleClose}>
                Clear
              </Button>
            ) : (
              <Button className={classes.actionText} onClick={handleClose}>
                Ok
              </Button>
            )}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default SpecialAlert;
